// "B2C 수익성 (추정)" 블록의 표시 규칙 — 순수 함수만 둔다(A-4, 2026-08-14).
// 백엔드 accountSegments.b2cEconomics 를 화면에 어떻게 늘어놓을지만 정하고, 값 자체는
// 절대 다시 계산하지 않는다. 프론트에서 한 번 더 계산하면 백엔드가 배분해 맞춰둔
// canonical KRW 와 어긋난다(세그먼트 합 = 전체 원가 불변식이 프론트에서 깨진다).

// 기여이익률 — fmt.pct 는 소수 첫째 자리까지라 61.0% 로 뭉개진다. 이 지표는 경영 판단에
// 쓰이고 61.02% 처럼 둘째 자리까지 보고되므로 여기서만 따로 포맷한다.
export function formatContributionRate(rate) {
  if (rate === null || rate === undefined || !Number.isFinite(Number(rate))) return "—";
  return `${(Number(rate) * 100).toFixed(2)}%`;
}

// 기여이익 계산에 넣지 않는 비용들. 성격이 달라 섞으면 해석이 무너지므로 나란히만 둔다 —
// 무상 원가를 빼면 지표가 음수가 되는데 그건 수익성 악화가 아니라 프로모션 투자다.
//
// customerOther 는 0 이면 감춘다. 고객이면서 유료도 프로모션도 아닌 상태(환불만·휴면)라
// 평소엔 0 이고, 0 인 칸이 늘 떠 있으면 무슨 값인지 묻게 만든다. 대신 값이 생기면
// 반드시 보여야 한다 — 안 보이면 세그먼트 합이 안 맞는 것처럼 읽힌다.
export function secondaryCostRows(e) {
  if (!e) return [];
  const rows = [
    { key: "promotion", label: "무상 지급 고객", value: e.promotionCostKrw,
      hint: "프로모션 투자" },
    { key: "internal", label: "내부 사용", value: e.internalCostKrw,
      hint: "팀·QA·사내 CMS" },
    { key: "unknown", label: "미분류", value: e.unknownCostKrw,
      hint: "분류 근거 부족" },
  ];
  if (e.customerOtherCostKrw) {
    rows.push({ key: "customerOther", label: "기타 고객", value: e.customerOtherCostKrw,
                hint: "환불만·휴면" });
  }
  if (e.systemCostKrw) {
    rows.push({ key: "system", label: "시스템", value: e.systemCostKrw,
                hint: "익명·검증용 식별자" });
  }
  return rows;
}

// 내부 비용 상세 — ai@sedaily.com 한 계정이 전체 원가의 30%대를 차지해(2026-08-14 감사)
// 합계만 보면 "내부 비용" 의 정체를 알 수 없다. 백엔드가 합계에 맞춰 배분해 둔 값을
// 그대로 쓴다(합이 항상 internalCostKrw 와 같다).
const INTERNAL_LABELS = {
  adminDevQa: "관리자·개발 QA",
  test: "테스트 계정",
  sedailyCms: "사내 CMS(sedaily)",
  internalDemo: "내부 데모",
};

export function internalBreakdownRows(e) {
  const bd = e?.internalCostBreakdownKrw;
  if (!bd) return [];
  return Object.keys(INTERNAL_LABELS)
    .filter((k) => k in bd)
    .map((k) => ({ key: k, label: INTERNAL_LABELS[k], value: bd[k] }));
}
